// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lnpl8MdFTauIBCRt7PRt {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  flex-direction: column;
  text-align: center;
  color: rgba(0, 0, 0, 0.76)
}

.Lnpl8MdFTauIBCRt7PRt p {
  margin: 10px
}`, "",{"version":3,"sources":["webpack://./src/components/EmailVerify/components/PageFooter/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF","sourcesContent":[".pageFooter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 10px;\n  flex-direction: column;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.76)\n}\n\n.pageFooter p {\n  margin: 10px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageFooter": `Lnpl8MdFTauIBCRt7PRt`
};
export default ___CSS_LOADER_EXPORT___;
